import { Suspense, lazy, useEffect, useState } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import { theme } from "styled-tools";
import { MetaProps, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { tncPagesSEOData } from "src/config/seo_api";

interface IProps {
  app: {
    brandId: number;
  };
  theme: any
}

const ResponsibleGambling: React.SFC<IProps> = props => {
  const {
    app: { brandId }, theme
  } = props;
  const { config: { showAPISEOData } } = theme;
  const [seoObjects, setseoObjects] = useState({} as MetaProps);

  //for SEO
  useEffect(() => {
    if (showAPISEOData) {
      const getSeoData = tncPagesSEOData();
      const pathName = "/about/responsible-gambling";

      getSeoData.then(resp => {
        const { objects } = resp;
        const seoData = objects.find((obj: any) => {
          const { metadata = {} } = obj;
          if (metadata.pathname && metadata.pathname === pathName) {
            return obj;
          }

        }) || {};

        const { metadata = {} } = seoData;
        setseoObjects(metadata);

      }).catch(error => console.log(`[${pathName}]:Error in SEO API`))
    }

  }, []);

  const Contents = brandId && brandId === 32 ? lazy(() => import("src/components/fine_print/respgamg32")) :
    brandId && (brandId === 39 || brandId === 40) ? lazy(() => import("src/components/fine_print/respgamg39")) :
    brandId && (brandId === 46 || brandId === 47) ? lazy(() => import("src/components/fine_print/respgamg46")) :
    lazy(() => import("src/components/fine_print/respgamg31"))

  return (
    <>
      {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

      <ContentWrapper>
        <Suspense fallback={<div>Loading ... </div>}>
          <Contents />
        </Suspense>
      </ContentWrapper></>
  );
};

export default withTheme(withAppContext(ResponsibleGambling));



const ContentWrapper = styled.div`
	max-width: 800px;
	margin: 0 auto;
	font-size: 12px;
	padding: 1.5em 1.25em;
    color: white;
    text-transform: capitalize;
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-top: 1.23em;
	}

	h1 {
		font-size: 18px;
    /* color: #f4a322; */
    color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
	}

	h2 {
		font-size: 16px;
    color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
	}

  .addColor {
    font-size: 18px;
    /* color: #f4a322; */
    color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
  }

  .policyInternWrap {
    position: relative;
    color: ${theme('palette.nametext')};
  }

  .downloadAction {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    top: 0;
  }

  .downloadAction a {
    width: 92px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 0;
    border-radius: 5px;
    font-size: 12px;
    color: #fff;
    text-decoration: none;
    background: linear-gradient(180deg, #FFCF84 0%, #AC6700 100%);
  }

  .downloadAction a:hover {
    background: linear-gradient(180deg, #FFCF84 0%, #000000 100%);
  }

  .downloadAction svg {
    width: 12.353px;
    height: 11.25px;
  }

  .brandColor {
    color: #8998F4;
  }

	h3 {
		font-size: 14px;
	}

	ul ul,
	ol {
		margin: 1em 0;
	}

	li {
		margin: 0.75em 0;
	}

	a {
		/* color: #e9d967; */
    color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
		text-decoration: underline;
        cursor: pointer;
	}

  .addColor {
    font-size: 18px;
    /* color: #f4a322; */
    color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
  }

  .policyInternWrap {
    position: relative;
    color: ${theme('palette.nametext')};
  }

  .downloadAction {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    top: 0;
  }

  .downloadAction a {
    width: 92px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 0;
    border-radius: 5px;
    font-size: 12px;
    color: #fff;
    text-decoration: none;
    background: linear-gradient(180deg, #FFCF84 0%, #AC6700 100%);
  }

  .downloadAction a:hover {
    background: linear-gradient(180deg, #FFCF84 0%, #000000 100%);
  }

  .downloadAction svg {
    width: 12.353px;
    height: 11.25px;
  }

  .brandColor {
    color: #8998F4;
  }

  .bgColor {
    background: #f5f5f5;
    padding: 2rem;
    margin: 0;
    border-radius: 1rem;
  }

`;